
define('ldsh!modules/contact/list/template', [], function() {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '<h1>Contact</h1>\n<a class="btn btn-default" href="#/contact/create">Create</a>\n<table class="table table-striped">\n\t<thead>\n  \n  <th>\n   firstName\n  </th>\n  \n  <th>\n   lastName\n  </th>\n  \n  <th>\n   email\n  </th>\n  \n  <th>\n   phone1\n  </th>\n  \n  <th>\n   phone2\n  </th>\n\n  <th>\n\n  </th>\n    <th>\n\n  </th>\n\t</thead>\n\t<tbody class="Contact-body">\n\t</tbody>\n</table>';

}
return __p
};});

